"use strict";require('@ebay/skin/tabs');